import { render } from "./ThemePalettesEdit.vue.js?vue&type=template&id=6539151c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesEdit.vue?vue&type=template&id=6539151c"
import script from "./ThemePalettesEdit.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesEdit.vue?vue&type=script&lang=js"
export * from "./ThemePalettesEdit.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ThemePalettesEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6539151c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6539151c', __exports__)) {
    api.reload('6539151c', __exports__)
  }
  
  module.hot.accept("./ThemePalettesEdit.vue.js?vue&type=template&id=6539151c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesEdit.vue?vue&type=template&id=6539151c", () => {
    api.rerender('6539151c', render)
  })

}


export default __exports__